/**
 * Formatea número como divisa europea: 1.999,99 €
 * No depende del locale del sistema.
 */
export function formatCurrency(value) {
  const num = Number(value) || 0;
  return formatEuro(num);
}

/**
 * Núcleo del formateador — siempre produce: 1.999,99 €
 */
export function formatEuro(num) {
  const fixed = Math.abs(num).toFixed(2);           // "1999.99"
  const [intPart, decPart] = fixed.split('.');
  // Añade puntos de miles
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const sign = num < 0 ? '- ' : '';
  return `${sign}${intFormatted},${decPart} €`;
}

/**
 * Parsea cualquier formato de divisa a número:
 * "1.999,99 €" → 1999.99
 * "1999.99"    → 1999.99
 * "1999,99"    → 1999.99
 * "1999"       → 1999
 */
export function parseCurrency(str) {
  const s = String(str).trim().replace(/\s*€\s*$/, '');
  // Si tiene coma: el punto es separador de miles, la coma es decimal
  if (s.includes(',')) {
    return parseFloat(s.replace(/\./g, '').replace(',', '.')) || 0;
  }
  // Si no tiene coma: número estándar (puede tener punto decimal)
  return parseFloat(s) || 0;
}

/**
 * Obtiene las iniciales del nombre para el avatar
 */
export function getInitials(name = '') {
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

/**
 * Calcula el ROAS (Return On Ad Spend) = ingresos / coste
 */
export function calculateROAS(income, cost) {
  const inc = Number(income) || 0;
  const cos = Number(cost) || 0;
  if (cos === 0) return null;
  return (inc / cos).toFixed(2);
}

/**
 * Genera un ID único simple
 */
export function generateId() {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}

/**
 * Formatea fecha ISO a formato legible
 */
export function formatDate(isoString) {
  if (!isoString) return '—';
  return new Date(isoString).toLocaleDateString('es-ES', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

/**
 * Normaliza un adjunto de una colaboración.
 * Los registros anteriores a la migración guardaban solo una etiqueta
 * ("Contrato @usuario"); los nuevos guardan el fichero real. Los antiguos se
 * marcan como `legacy`: se muestran, pero no se pueden descargar.
 */
export function normalizeAttachment(value) {
  if (!value) return null;
  if (typeof value === 'string') return { filename: value, legacy: true };
  return { legacy: false, ...value };
}

/**
 * Tamaño de un archivo para leerlo de un vistazo: 845 KB, 12,4 MB.
 */
export function formatearTamano(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024 * 1024) return `${Math.max(1, Math.round(n / 1024))} KB`;
  return `${(n / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}
